"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _moment = _interopRequireDefault(require("moment"));
var _crc = _interopRequireDefault(require("crc-32"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /*
 * MIT License
 *
 * Copyright (c) 2023 Massimo Candela <https://massimocandela.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var _getFingerprint = function _getFingerprint(object, algorithm) {
  switch (_typeof(object)) {
    case "object":
      if (object == null) {
        return "o:null";
      } else if (object._isAMomentObject) {
        return "m:".concat(object.toISOString());
      } else if (object instanceof Date) {
        return "m:".concat((0, _moment["default"])(object).toISOString());
      } else if (Array.isArray(object)) {
        return "a:[".concat(object.map(function (i) {
          return getObjectFingerprint(i, algorithm);
        }), "]");
      } else {
        return "o:".concat(getObjectFingerprint(object, algorithm));
      }
    case "boolean":
      return "b:".concat(object ? "t" : "f");
    case "function":
      throw new Error("You cannot pass a function as data item");
    case "number":
      return "n:".concat(object.toString());
    case "string":
      return "s:".concat(object);
    case "undefined":
      return "u";
  }
};
var getObjectFingerprint = function getObjectFingerprint(value, algorithm) {
  try {
    if (_typeof(value) === "object") {
      var sortedKeys = Object.keys(value).sort();
      var buff = "";
      var _iterator = _createForOfIteratorHelper(sortedKeys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          buff += "".concat(key, "<").concat(index(value[key], algorithm), ">");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return buff;
    } else {
      return JSON.parse(value);
    }
  } catch (e) {
    return "nn";
  }
};
function index(object, algorithm) {
  if (algorithm) {
    return algorithm(_getFingerprint(object, algorithm));
  } else {
    return _crc["default"].str(_getFingerprint(object)).toString(16);
  }
}